export default __webpack_public_path__ + "static/Morgensterns-74bb73d8a158d3d3cf173ade9ec388be.png";